export default __webpack_public_path__ + "static/media/AstronomyMercury_03.cc8bfa23.png";